import * as api from '../utils/api';

export const checkSession = () => async (dispatch) => {
  dispatch({ type: 'CHECK_SESSION_REQUEST' });
  try {
    const data = await api.checkSession();
    if (data.email) {
      dispatch({ type: 'CHECK_SESSION_SUCCESS', user: data });
    } else {
      dispatch({ type: 'CHECK_SESSION_FAILURE' });
    }
  } catch (error) {
    // Session check failed - user not authenticated or server unreachable
    dispatch({ type: 'CHECK_SESSION_FAILURE' });
  }
};

export const login = (idToken) => async (dispatch) => {
  dispatch({ type: 'LOGIN_REQUEST' });
  try {
    const data = await api.login(idToken);
    dispatch({ type: 'LOGIN_SUCCESS', user: data });
  } catch (error) {
    console.error('Login error:', error);
    dispatch({ type: 'LOGIN_FAILURE', error: error.message });
  }
};

export const logout = () => async (dispatch) => {
  try {
    await api.logout();
    dispatch({ type: 'LOGOUT_SUCCESS' });
  } catch (error) {
    // Clear state anyway even if server call fails
    dispatch({ type: 'LOGOUT_SUCCESS' });
  }
};
